<template>
    <div class="page-content">
        <div class="page-tool-bar">
            <div class="el-btn-group">
                <el-button type="primary" size="small" icon="el-icon-lx-add" @click="addRole">新建</el-button>
                <el-button
                    type="warning"
                    plain
                    size="small"
                    icon="el-icon-lx-add"
                    :disabled="multipleSelection.length != 1"
                    @click="editRole(null)"
                    >修改</el-button
                >
                <el-button
                    type="danger"
                    plain
                    size="small"
                    icon="el-icon-lx-delete"
                    :disabled="multipleSelection.length <= 0"
                    @click="deleteRole(null)"
                    >删除</el-button
                >
            </div>

            <div class="icon-group">
                <span title="搜索" class="icon-box" @click="search">
                    <Icon color="#606266">
                        <Search />
                    </Icon>
                </span>
                <span class="icon-box" @click="refreshRoleList">
                    <Icon color="#606266">
                        <Refresh />
                    </Icon>
                </span>
            </div>
        </div>
        <el-table :data="roleList" row-key="id" size="small" height="100%" @selection-change="handleSelectionChange">
            <el-table-column align="center" type="selection" min-width="10%"> </el-table-column>
            <el-table-column align="center" prop="roleName" label="名称" min-width="30%"> </el-table-column>
            <el-table-column align="center" label="是否可用" min-width="12%">
                <template slot-scope="scop">
                    <el-tag type="success" size="small" effect="plain" v-if="scop.row.status == '1'">正常</el-tag>
                    <el-tag type="danger" size="small" effect="plain" v-if="scop.row.status == '0'">禁用</el-tag>
                </template>
            </el-table-column>
            <el-table-column align="center" prop="remarks" label="备注" min-width="30%"> </el-table-column>
            <el-table-column fixed="right" align="center" label="操作" min-width="35%">
                <template slot-scope="scop">
                    <div class="operation">
                        <div>
                            <Icon size="16">
                                <Edit24Regular />
                            </Icon>
                            <span class="operation-label" @click="editRole(scop.row.id)">修改</span>
                        </div>
                        <div>
                            <Icon size="16" style="color: red">
                                <Delete24Regular />
                            </Icon>
                            <span style="color: red" class="operation-label" @click="deleteRole(scop.row.id)">删除</span>
                        </div>
                        <div>
                            <Icon size="16">
                                <Settings24Regular />
                            </Icon>
                            <span class="operation-label" @click="showAuth(scop.row)">角色授权</span>
                        </div>
                        <div>
                            <Icon size="16">
                                <Person24Filled />
                            </Icon>
                            <span class="operation-label" @click="allotUser(scop.row)">分配用户</span>
                        </div>
                    </div>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-box">
            <el-pagination
                @size-change="sizeChange"
                @current-change="currentChange"
                :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalNum"
                background
                :pager-count="7"
            >
            </el-pagination>
        </div>

        <!-- 新增/查看/修改用户信息 -->
        <el-dialog :title="roleStates[roleState]" :visible.sync="showDialog" width="400px" @close="closeDialog">
            <div>
                <el-form :model="role" ref="userForm" :rules="rules" label-width="80px" :inline="true" size="mini">
                    <el-form-item label="角色名称" prop="roleName">
                        <el-input style="width: 200px" v-model="role.roleName" size="small"></el-input>
                    </el-form-item>

                    <el-form-item label="是否可用" prop="status">
                        <el-select
                            style="width: 200px"
                            v-model="role.status"
                            size="small"
                            placeholder="请选择"
                            :disabled="roleState == 'check'"
                        >
                            <el-option label="正常" :value="1"> </el-option>
                            <el-option label="禁用" :value="0"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="排序">
                        <el-input-number
                            v-model="role.sort"
                            size="small"
                            style="width: 200px"
                            label=""
                            :min="1"
                            :max="100"
                            :step="1"
                            :controls="true"
                            controls-position="both"
                        >
                        </el-input-number>
                    </el-form-item>

                    <el-form-item label="备注">
                        <el-input type="textarea" :rows="2" v-model="role.remarks" size="small" style="width: 200px"></el-input>
                    </el-form-item>
                </el-form>
            </div>

            <div slot="footer" class="flex justify-end">
                <el-button @click="closeDialog">关闭</el-button>
                <el-button type="primary" @click="submitForm" v-if="roleState != 'check'">确定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="权限设置" :close-on-click-modal="false" v-dialogDrag width="350px" :visible.sync="power">
            <el-form
                class="auth"
                :model="inputForm"
                status-icon
                v-loading="loading"
                ref="inputForm"
                @keyup.enter.native="inputFormSubmit()"
                @submit.native.prevent
            >
                <el-tabs type="border-card">
                    <el-tab-pane>
                        <span slot="label"><i class="fa fa-navicon"></i> 系统功能</span>
                        <el-scrollbar style="height: 450px">
                            <el-tree
                                :data="menuList"
                                :props="{
                                    label: 'menuName',
                                    children: 'children'
                                }"
                                node-key="id"
                                ref="menuListTree"
                                :default-expanded-keys="['1']"
                                :default-checked-keys="defaultCheck"
                                show-checkbox="true"
                                check-strictly="true"
                                default-expand-all="true"
                            >
                            </el-tree>
                        </el-scrollbar>
                    </el-tab-pane>
                    <el-tab-pane>
                        <span slot="label"><i class="fa fa-database"></i> 应用功能</span>
                        <el-scrollbar style="height: 450px">
                            <el-tree
                                :data="appMenuList"
                                :props="{
                                    label: 'menuName',
                                    children: 'children'
                                }"
                                node-key="id"
                                ref="appMenuTree"
                                :default-expanded-keys="['1']"
                                :default-checked-keys="defaultCheck"
                                show-checkbox="true"
                                check-strictly="true"
                                default-expand-all="true"
                            >
                            </el-tree>
                        </el-scrollbar>
                    </el-tab-pane>
                </el-tabs>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" icon="el-icon-check" size="small" plain @click="savePowerSubmit()" v-noMoreClick>保存</el-button>
                <!-- <el-button type="primary" icon="el-icon-check" size="small" plain @click="savePowerSubmit()">保存</el-button> -->
            </span>
        </el-dialog>

        <AllotUser ref="allotUser" :role="currentRole" />
    </div>
</template>

<script>
import AllotUser from '@/components/organization/AllotUser.vue';
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { Edit24Regular, Delete24Regular, Person24Filled, Settings24Regular } from '@v2icons/fluent';
import { GridDots, ArrowDown, Refresh, Printer, Search } from '@v2icons/tabler';
import { getRoleList, getRoleById, editRole, addRole, deleteRole, addMenusIntoRole, getAuthorize } from '@/api/role.js';
import { getMenuList } from '@/api/menu.js';
import { exprotExcel, importTemplate } from '@/utils/request.js';
export default {
    components: {
        GridDots,
        ArrowDown,
        Refresh,
        Printer,
        Edit24Regular,
        Person24Filled,
        Delete24Regular,
        Settings24Regular,
        AllotUser,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search
    },
    props: {
        checkState: String,
        queryForm: Object,
        resetCheckState: Function
    },
    watch: {
        checkState(val) {
            if (val == 'check') {
                this.resetRoleList();
                this.getRoleList(this.queryForm);
                this.$emit('resetCheckState');
            } else if (val == 'reset') {
                this.resetRoleList();
                this.getRoleList();
                this.$emit('resetCheckState');
            }
        }
    },
    data() {
        return {
            isImportDate: false,
            power: false,
            loading: false,
            showDialog: false,
            pageSize: 10,
            currentPage: 1,
            totalNum: 10,
            currentRoleId: '',
            currentRole: {},
            roleState: 'add',
            roleStates: {
                add: '添加角色',
                check: '查看角色',
                edit: '编辑角色'
            },
            menuList: [],
            appMenuList: [],
            defaultMenuKeys: [],
            multipleSelection: [],
            isSearch: false,
            roleList: [],
            role: {
                roleName: '',
                sort: 10,
                remarks: '',
                status: 1
            },
            btnLoading: false,
            rules: {
                roleName: [{ required: true, message: '角色名称不能为空', trigger: 'blur' }],
                status: [{ required: true, message: '是否可用不能为空', trigger: 'blur' }]
            },
            defaultCheck: []
        };
    },
    created() {
        this.getRoleList();
    },
    methods: {
        search() {
            this.isSearch = !this.isSearch;
            this.$emit('send', this.isSearch);
        },
        allotUser(role) {
            //console.log(role);
            this.currentRole = role;
            setTimeout(() => {
                this.$refs.allotUser.init();
            }, 200);
        },
        resetRoleList() {
            this.pageSize = 10;
            this.currentPage = 1;
            this.userList = [];
        },
        resetDialog() {
            this.$refs.userForm.resetFields();
            this.roleState = 'add';
            this.showDialog = false;
            this.currentRoleId = '';
            this.role = {
                roleName: '',
                sort: 10,
                remarks: '',
                status: 1
            };
        },
        closeDialog() {
            this.resetDialog();
        },
        submitForm() {
            if (this.roleState == 'add') {
                this.$refs.userForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        addRole({ ...this.role }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: '新增角色成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetRoleList();
                                this.resetDialog();
                                this.getRoleList();
                            }
                        });
                    }
                });
            } else if (this.roleState == 'edit') {
                this.$refs.userForm.validate((valid) => {
                    if (valid) {
                        console.log('submit');
                        const role = this.role;
                        delete role.mppMenuList;
                        delete role.deleteFlag;
                        delete role.orderBy;
                        editRole({ ...role }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: '编辑角色成功',
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetRoleList();
                                this.resetDialog();
                                this.getRoleList();
                            }
                        });
                    }
                });
            }
        },
        addRole() {
            this.showDialog = true;
            this.roleState = 'add';
        },
        checkUser(roleId) {
            console.log(roleId);
            this.currentRoleId = roleId;
            this.getRoleById();
            this.showDialog = true;
            this.roleState = 'check';
        },
        editRole(roleId) {
            //console.log('role', roleId);
            if (roleId) {
                this.currentRoleId = roleId;
                this.getRoleById();
            } else {
                this.role = { ...this.role, ...this.multipleSelection[0] };
            }

            this.showDialog = true;
            this.roleState = 'edit';
        },
        deleteRole(roleId) {
            let ids = '';
            if (roleId) {
                ids = roleId;
            } else {
                ids = this.multipleSelection.map((role) => role.id).join(',');
            }
            console.log({ ids });
            this.$confirm('确定删除所选项吗？', '提示', {
                type: 'warning'
            })
                .then(() => {
                    deleteRole({ ids }).then((res) => {
                        if (res.success) {
                            this.$message({
                                message: '删除角色成功',
                                type: 'success',
                                duration: 2000
                            });
                            this.resetRoleList();
                            this.getRoleList();
                        }
                    });
                })
                .catch(() => {});
        },
        /**
         * 导出出岗位信息
         */
        exportPostList() {
            this.btnLoading = true;
            exprotExcel(`/mpp/role/export`, this.post, this.btnLoading);
        },
        /**
         * 导出模板
         */
        importTemplate() {
            this.btnLoading = true;
            importTemplate(`/mpp/role/importTemplate`, this.btnLoading);
        },
        /**
         * 导入数据
         */
        isImport() {
            this.isImportDate = !this.isImportDate ? true : false;
        },
        upload(params) {
            const file = params.file;
            const formData = new FormData();
            formData.append('file', file);
            console.log({ formData });
            importDate(`/mpp/post/importData`, formData);
            this.refreshPostList();
        },
        refreshRoleList() {
            this.resetRoleList();
            this.getRoleList();
        },
        getRoleList(query = {}) {
            this.loading = true;
            getRoleList({ ...query, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                this.loading = false;
                if (res.success) {
                    this.roleList = res.page.list;
                    this.totalNum = res.page.total;
                }
            });
        },
        getRoleById() {
            getRoleById({ id: this.currentRoleId }).then((res) => {
                if (res.success) {
                    this.role = { ...this.role, ...res.mppRole };
                }
            });
        },
        handleSelectionChange(value) {
            console.log(value);
            this.multipleSelection = value;
        },
        currentChange(page) {
            this.currentPage = page;
            this.getRoleList();
        },
        sizeChange(size) {
            this.pageSize = size;
            this.getRoleList();
        },
        showAuth(row) {
            this.currentRoleId = row.id;
            this.power = true;
            this.loading = true;
            //内部权限数据
            this.getAllMenu();
            //应用权限数据
            this.getAppMenu();
            //展示选中数据
            this.getAllCheckMenu();
        },
        getAllMenu() {
            getMenuList({ menuCategory: 1 }).then((res) => {
                if (res.success) {
                    //var menuData = res.value;
                    this.menuList = res.listMenu;
                }
            });
        },
        getAppMenu() {
            getMenuList({ menuCategory: 2 }).then((res) => {
                if (res.success) {
                    //var menuData = res.value;
                    this.appMenuList = res.listMenu;
                }
            });
        },
        getAllCheckMenu() {
            getAuthorize({ roleId: this.currentRoleId }).then((res) => {
                if (res.success) {
                    var roleMenus = res.roleMenus;
                    var menuIds = [];
                    for (var i = 0; i < roleMenus.length; i++) {
                        menuIds.push(roleMenus[i].menuId);
                    }
                    this.defaultCheck = menuIds;
                    setTimeout(() => {
                        this.loading = false;
                    }, 5000);
                }
            });
        },
        savePowerSubmit() {
            var menuCheckKeys = this.$refs.menuListTree.getCheckedKeys(); //.concat(this.$refs.menuListTree.getHalfCheckedKeys());
            var appCheckKeys = this.$refs.appMenuTree.getCheckedKeys();
            var checkMenuIds = menuCheckKeys.join(',');
            var checkAppIds = appCheckKeys.join(',');
            console.log(checkAppIds);
            addMenusIntoRole({ roleId: this.currentRoleId, menuIds: checkMenuIds, appIds: checkAppIds }).then((res) => {
                if (res.success) {
                    this.$message({
                        type: 'success',
                        message: `角色授权成功`,
                        duration: 3000
                    });
                } else {
                    this.$message.error('角色授权失败');
                }
                this.power = false;
            });
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #eee;
  padding: 15px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  button{
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;

    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>
